import React from "react";

const StatusIcon = ({icon: Icon, ...props}) => (<Icon {...props} />);

export default StatusIcon;